import {
	CircleDashed,
	CircleDollarSign,
	CircleMinus,
	CircleSlash,
	type LucideIcon,
} from "lucide-react";
import { cn } from "@/v2/lib/utils";
import type { Entry } from "./normalize";

const BILLABLE_ICON: Record<
	Entry["billableCategory"],
	{ Icon: LucideIcon | null; color: string; label: string }
> = {
	billable: {
		Icon: CircleDollarSign,
		color: "text-billable",
		label: "Billable",
	},
	non_billable: {
		Icon: CircleSlash,
		color: "text-muted-foreground",
		label: "Non-billable",
	},
	billable_credit: {
		Icon: CircleMinus,
		color: "text-billable-credit",
		label: "Credit",
	},
	unknown: {
		Icon: CircleDashed,
		color: "text-muted-foreground",
		label: "Unknown",
	},
};

export function getBillableMeta(category: Entry["billableCategory"]) {
	return BILLABLE_ICON[category];
}

interface BillableIconProps {
	category: Entry["billableCategory"];
	className?: string;
}

/**
 * Shared billable-category glyph. Default sizing comes from the consumer via
 * `className` (e.g. "size-3.5" in chips, "size-5" in the table cell, "size-3"
 * inline with stats labels). Color is set per-category so it stays in sync
 * across surfaces.
 */
export function BillableIcon({ category, className }: BillableIconProps) {
	const meta = BILLABLE_ICON[category];
	if (!meta?.Icon) return null;
	const { Icon, color } = meta;
	return <Icon className={cn("shrink-0", color, className)} strokeWidth={2} />;
}
